export const formatDecimalAsTwoDigitPercentage = (value: number | null | undefined): string => {
    if (value == null) return '';

    // Convert decimal → percent
    const percent = value * 100;

    // Round to 2 decimals
    const rounded = Number(percent.toFixed(2));

    // Convert to string for trimming
    let text = rounded.toString();

    // Drop trailing .00 (whole number)
    if (text.endsWith('.00')) {
        text = text.slice(0, -3);
    }
    // Drop trailing .0 (one decimal)
    else if (text.endsWith('.0')) {
        text = text.slice(0, -2);
    }

    return `${text}%`;
};
